import { kea } from 'kea'
import PropTypes from 'prop-types';
import {filter, find} from 'lodash'
import { selector as configSelector } from '~/config'

import saga from './saga'
import i18n, {getLanguages} from '~/i18n'
const __ = i18n.t.bind(i18n);

export const getMenu = () => {
  return [
  {
    key: 'home',
    url: '/',
    label: __('Home'),
    type: 'link',
    icon: 'home'
  },
  {
    key: 'orders',
    url: '/orders/',
    label: __('Orders'),
    type: 'container',
    icon: 'check',
    children: [
      {
        key: 'orders_child',
        url: '/orders/',
        label: __('Orders'),
        type: 'link'
      },
      {
        key: 'events',
        url: '/events/',
        label: __('Events'),
        type: 'link'
      },
    ]
  },
  {
    key: 'products',
    url: '/products/',
    label: __('Products'),
    type: 'container',
    icon: 'tag',
    children: [
      {
        key: 'products_child',
        url: '/products/',
        label: __('Products'),
        type: 'link'
      },
      {
        key: 'collections',
        url: '/collections/',
        label: __('Collections'),
        type: 'link'
      },
      {
        key: 'videos',
        url: '/videos/',
        label: __('Videos'),
        type: 'link'
      },
      {
        key: 'access',
        url: '/product-accesses/',
        label: __('Access'),
        type: 'link'
      },
    ]
  },
  {
    key: 'discounts',
    url: '/discounts/',
    label: __('Discounts'),
    type: 'link',
    icon: 'minus-circle-o'
  },
  {
    key: 'analytics',
    url: '/analytics/',
    label: __('Analytics'),
    type: 'link',
    icon: 'area-chart'
  },
  {
    key: 'contacts',
    url: '/contacts/',
    label: __('Contacts'),
    type: 'link',
    icon: 'user'
  },
  {
    key: 'settings',
    url: '/settings/',
    label: __('Settings'),
    type: 'container',
    icon: 'setting',
    children: [
      {
        key: 'settings_child',
        url: '/settings/',
        label: __('Store'),
        type: 'link'
      },
      {
        key: 'checkout_settings',
        url: '/checkout-settings/',
        label: __('Checkout'),
        type: 'link'
      },
      {
        key: 'payment_methods',
        url: '/payment-methods/',
        label: __('Payment Methods'),
        type: 'link'
      },
      {
        key: 'shipping_methods',
        url: '/shipping-methods/',
        label: __('Shipping Methods'),
        type: 'link'
      },
      {
        key: 'taxes',
        url: '/taxes/',
        label: __('Taxes'),
        type: 'link'
      },

      {
        key: 'integrations',
        url: '/integrations/',
        label: __('Integrations'),
        type: 'link'
      },
    ]
  },
  {
    key: 'validate',
    url: '/validate/',
    label: __('Validate'),
    type: 'link',
    icon: 'qrcode'
  }
]
};


export default kea({
  path : () => ['root', 'menu'],

  actions : ({ constants }) => ({
    clickMenuItem: url => ({ url }),
    logout: true,
    changeLanguage: language => ({ language }),
  }),

  reducers : ({ actions, constants }) => ({
    menu: [getMenu(), PropTypes.array, {
    }]
  }),

  selectors : ({ constants, selectors }) => ({
    languages: [
      () => [
        configSelector
      ], (config) => {
        return getLanguages();
      }
    ],
    language: [
      () => [
        configSelector,
        selectors.languages
      ], (config, languages) => {
        return find(languages, {value: config.uiLanguage});
      }
    ],
    activeItem: [
      () => [
        configSelector
      ],
      (config) => {
        const menu = getMenu();
        const { activePath } = config;
        if(activePath && menu) {
          const item = find(menu, (item) => {
            if(activePath.indexOf(item.url) === 0 && item.url !== '/') {
              return true;
            }

            const child = find(item.children, (child) => {
              return activePath.indexOf(child.url) === 0 && child.url !== '/';
            });
            if(child) {
              return true;
            }
          });

          if(item) {
            return item;
          }else {
            const rootItem = find(menu, {url: activePath});
            if(rootItem) {
              return rootItem;
            }
          }
        }
        return null;
      },
      PropTypes.object
    ],
    selectedKeys: [
      () => [
        configSelector,
        selectors.activeItem
      ],
      (config, activeItem) => {
        const { activePath } = config;
        let keys = [];
        if(activeItem) {
          keys = [activeItem.key];
        }

        if(activePath && activeItem && activeItem.children) {
          const child = find(activeItem.children, (child) => {
            return activePath.indexOf(child.url) === 0 && child.url !== '/';
          });

          if(child) {
            keys = [...keys, child.key];
          }
        }

        return keys;
      },
      PropTypes.array
    ],
    subMenu: [
      () => [
        selectors.activeItem
      ],
      (activeItem) => {
        if(activeItem && activeItem.type === 'container') {
          return activeItem.children;
        }
      },
      PropTypes.array
    ]
  }),
  ...saga
})
